'use strict';

var w3cContext = require('@trustvc/w3c-context');
var assertions = require('./BitstringStatusList/assertions');
var utils = require('./utils');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const VCCredentialStatusTypeToVCCredentialSubjectType = {
  StatusList2021Credential: "StatusList2021",
  BitstringStatusListCredential: "BitstringStatusList"
};
const createCredentialStatusPayload = /* @__PURE__ */ __name(async (options, keyPair, type = "StatusList2021Credential", cryptoSuite = "BbsBlsSignature2020") => {
  try {
    const { id, credentialSubject } = options;
    switch (type) {
      case "StatusList2021Credential":
        assertions._checkCredentialSubjectForStatusList2021Credential(credentialSubject);
        break;
      default:
        throw new Error(`Unsupported type: ${type}`);
    }
    if (!credentialSubject.id && id) {
      credentialSubject.id = `${id}#list`;
    }
    const context = [
      w3cContext.CredentialContextVersion.v1
    ];
    if (cryptoSuite === "BbsBlsSignature2020") {
      context.push(w3cContext.BBS_V1_URL);
    }
    if (type === "StatusList2021Credential") {
      context.push(w3cContext.STATUS_LIST_2021_CREDENTIAL_URL);
    }
    const validFrom = await utils.getValidFromDateFromCredentialStatusVC(id);
    const vc = {
      "@context": context,
      type: [
        "VerifiableCredential",
        type
      ],
      issuer: keyPair.controller,
      issuanceDate: (/* @__PURE__ */ new Date()).toISOString(),
      validFrom,
      credentialSubject
    };
    return vc;
  } catch (err) {
    if (!(err instanceof Error)) {
      throw new Error("An error occurred while signing the credential status VC.");
    }
    throw err;
  }
}, "createCredentialStatusPayload");
const isCredentialStatusStatusList = /* @__PURE__ */ __name((credentialStatus) => {
  try {
    utils.assertCredentialStatusStatusListType(credentialStatus?.type);
    return true;
  } catch (err) {
    return false;
  }
}, "isCredentialStatusStatusList");

exports.VCCredentialStatusTypeToVCCredentialSubjectType = VCCredentialStatusTypeToVCCredentialSubjectType;
exports.createCredentialStatusPayload = createCredentialStatusPayload;
exports.isCredentialStatusStatusList = isCredentialStatusStatusList;
